// ✅ firebase-notifications.js
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./firebase"; // 🔹 استخدم التطبيق الموجود في firebase.js
//

//init
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

     
      await navigator.serviceWorker.ready;

// 🔸 إنشاء خدمة الإشعارات
const messaging = getMessaging(app);

// 🔸 رابط السيرفر المحلي (اللي أنشأناه بالـ Node.js)
const FCM_SERVER = "http://localhost:8080";// i think here

// 🔹 دالة تطلب إذن المستخدم وتربط التوكن بالسيرفر
export async function requestPermissionAndRegister(uid) {
  console.log("start rigetser")
  try {
    console.log("🔔 طلب الإذن من المستخدم لتفعيل الإشعارات...");
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("🚫 المستخدم رفض السماح بالإشعارات");
      return;
    }

    // 🔹 جلب التوكن من FCM
    const token = await getToken(messaging, {
      vapidKey: "BO1H6Lz4KfNQ-Vz8TK-jHWH_VVzb0-3la-izNAOHfCWMVPfvxD71L5B8S47ANQXD0uxa9t9EP7cElLBknbAhDxs", 
      // ⬅️ استبدلي هذا بالمفتاح العام من Firebase Cloud Messaging
       serviceWorkerRegistration: registration
    });
console.log("point A")
    if (token) {
      console.log("✅ FCM Token:", token);

      // 🔹 إرسال التوكن للسيرفر لتخزينه حسب المستخدم
      const response = await fetch(`${FCM_SERVER}/register-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid, token }),
      });

      if (response.ok) {
        console.log(`✅ Token registered successfully for: ${uid}`);
      } else {
        console.error("❌ فشل إرسال التوكن للسيرفر");
      }
    }
  } catch (err) {
    console.error("❌ حدث خطأ أثناء تسجيل الإشعارات:", err);
  }
}

// 🔹 استقبال الإشعارات أثناء عمل التطبيق (Foreground)
onMessage(messaging, (payload) => {
  console.log("📩 رسالة جديدة:", payload);
  new Notification(payload.notification.title, {
    body: payload.notification.body,
    icon: "/logo192.png",
  });
});
export { messaging };

